import React from 'react';
import { Container } from '../Container';
import { Section } from '../Section';
import { Reveal } from '../Reveal';
import { AppImage } from '../AppImage';
import { nextSteps } from '../../data/contact';
import { contactStepImages } from '../../data/contactImages';
export function NextSteps() {
  return <Section tone="surface" bordered labelledBy="next-steps-title" data-id="element-372" data-mp="3p65v30mqvi9y">
      <Container data-id="element-373" data-mp="gr49due6s0i4">
        <Reveal data-id="element-374" data-mp="gqm5qcp72k06">
          <h2 id="next-steps-title" className="max-w-[16ch] text-[40px] leading-[1.05] tracking-[-0.03em] text-ink lg:text-[56px]" data-id="element-375" data-mp="gs70a2bie2y1">
            What happens next.
          </h2>
        </Reveal>

        <ol className="mt-14 border-t border-hairline lg:mt-16" data-id="element-376" data-mp="712m34tnqm49">
          {nextSteps.map((step, index) => <Reveal as="li" key={step.title} delay={index * 0.06} data-id="element-377" data-mp="byb3h36zem4g" data-mpi={index}>
              <div className="grid gap-5 border-b border-hairline py-8 md:grid-cols-12 md:items-center md:gap-8" data-id="element-378" data-mp="zp88dw0d0j67">
                <AppImage src={contactStepImages[index].image} alt={contactStepImages[index].alt} ratio="1:1" className="w-24 md:col-span-2 md:w-full" data-id="element-379" data-mp="14i1bkfg6jjg6" />
                <p className="text-small tabular-nums text-muted md:col-span-1" data-id="element-380" data-mp="1glgbxevcttd2">
                  {String(index + 1).padStart(2, '0')}
                </p>
                <div className="md:col-span-4" data-id="element-381" data-mp="1btgebt2rbcjn">
                  <h3 className="max-w-[22ch] text-[24px] leading-[1.25] tracking-[-0.025em] text-ink" data-id="element-382" data-mp="1qjnt9ytk2dfl">
                    {step.title}
                  </h3>
                  <p className="mt-3 text-small text-muted" data-id="element-383" data-mp="1lmxav4ua35r0">{step.duration}</p>
                </div>
                <p className="max-w-[46ch] text-body text-muted md:col-span-5" data-id="element-384" data-mp="1zihu61dx5pyy">
                  {step.description}
                </p>
              </div>
            </Reveal>)}
        </ol>
      </Container>
    </Section>;
}